export const PARTNER_ID_AMEX = 'amex';
export const PARTNER_ID_ENTERPRISE = 'enterprise';
export const PARTNER_ID_BAAS = 'baas';
export const PARTNER_ID_UMPQUA = 'umpqua';
export const PARTNER_ID_ADURO_ADVISORS = 'aduro-advisors';
export const PARTNER_ID_RSM_FAO = 'rsm-fao';
export const PARTNER_ID_RSM_VAR = 'rsm-var';

export const PARTNER_IDS = [PARTNER_ID_AMEX, PARTNER_ID_ADURO_ADVISORS, PARTNER_ID_RSM_FAO, PARTNER_ID_RSM_VAR];
export const SIGNUP_PARTNERS = [
  PARTNER_ID_AMEX,
  PARTNER_ID_ENTERPRISE,
  PARTNER_ID_BAAS,
  PARTNER_ID_UMPQUA,
  PARTNER_ID_ADURO_ADVISORS,
  PARTNER_ID_RSM_FAO,
  PARTNER_ID_RSM_VAR
];
export type SIGNUP_PARTNERS_TYPE = typeof SIGNUP_PARTNERS[number];

export const SIGNUP_PARTNERS_CUSTOM_MINIMUM_BILLING = [PARTNER_ID_ADURO_ADVISORS];

export const PARTNERS_SUPPORTING_NEW_SIGNUP_FLOW = [
  PARTNER_ID_AMEX,
  PARTNER_ID_UMPQUA,
  PARTNER_ID_ADURO_ADVISORS,
  PARTNER_ID_RSM_FAO,
  PARTNER_ID_RSM_VAR
];

export const PARTNER_TO_CHANNEL_MAP = {
  [PARTNER_ID_AMEX]: `${PARTNER_ID_AMEX}&cards=hide`,
  [PARTNER_ID_UMPQUA]: 'direct&cards=hide',
  [PARTNER_ID_ADURO_ADVISORS]: `${PARTNER_ID_ADURO_ADVISORS}&cards=hide`,
  [PARTNER_ID_RSM_FAO]: `${PARTNER_ID_RSM_FAO}&billing_plan=spend_annual_contract&implementation=guided`,
  [PARTNER_ID_RSM_VAR]: `${PARTNER_ID_RSM_VAR}&billing_plan=spend_annual_contract&implementation=guided`
};
